(()=>{
'use strict';
const fields=['title','tag','product_type','vendor','variants.title','variants.sku','variants.barcode'];
const build=text=>text.trim().split(/\s+/).filter(Boolean).map(word=>{const value='"'+word.replace(/\\/g,'\\\\').replace(/"/g,'\\"')+'"';return '('+fields.map(field=>field+':'+value).join(' OR ')+')';}).join(' AND ');
const params=new URLSearchParams(location.search);
const term=params.get('n_term');
const root=document.querySelector('[data-native-search]');
const globalPage=root?.dataset.mode==='search';
const forms=[...document.querySelectorAll('[data-ns-global-search]')];
if(globalPage){
 const original=params.get('q')||'';
 if(original && term===null && !/\b(?:title|body|tag|vendor|product_type|variants\.(?:sku|barcode|title)):/.test(original)){
  const next=new URL(location.href);next.searchParams.set('n_term',original);next.searchParams.set('q',build(original));location.replace(next.href);return;
 }
 if(term!==null){
  root.querySelector('[data-ns-search] [name=q]').value=term;
  document.title=term+' — Recherche NATURA';
  const filter=root.querySelector('.ns-native-filters');
  if(filter){const input=document.createElement('input');input.type='hidden';input.name='n_term';input.value=term;filter.append(input);const reset=filter.querySelector('.ns-reset');if(reset){const url=new URL(reset.href);url.searchParams.set('n_term',term);reset.href=url.href;}}
 }
}
if(globalPage){const filters=root.querySelector('.ns-native-filters');if(filters){
 const apply=event=>{event.preventDefault();const url=new URL(location.href);url.searchParams.delete('page');[...url.searchParams.keys()].filter(k=>k.startsWith('filter.')).forEach(k=>url.searchParams.delete(k));filters.querySelectorAll('input[name^="filter."]').forEach(input=>{if(input.value!==''&&(input.type!=='checkbox'||input.checked))url.searchParams.append(input.name,input.value);});location.assign(url.href);};
 filters.querySelector('[data-ns-apply]').addEventListener('click',apply);filters.addEventListener('keydown',event=>{if(event.key==='Enter')apply(event);});
}}
for(const form of forms){const submit=event=>{
 event.preventDefault();event.stopImmediatePropagation();
 const text=form.querySelector('[name=q]').value.trim();
 const url=new URL(form.dataset.action,location.origin);url.searchParams.set('type','product');
 const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
 if(text){url.searchParams.set('q',build(text));url.searchParams.set('n_term',text);}
 location.assign(url.href);
};form.querySelector('[data-ns-search-button]').addEventListener('click',submit);form.querySelector('[name=q]').addEventListener('keydown',event=>{if(event.key==='Enter')submit(event);});}
})();